import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';

import { ISSOEntityModel } from '../../../../../service/sso/interface/ISSOEntityModel';

interface Props {
  open: boolean;
  provider: ISSOEntityModel | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const SSODeleteConfirmModal = ({ open, provider, onConfirm, onCancel }: Props) => {
  if (!provider) return null;

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Удаление SSO провайдера</DialogTitle>

      <DialogContent dividers>
        <Typography>
          Вы уверены, что хотите удалить провайдера <strong>{provider.name}</strong>?
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onCancel}>Нет</Button>
        <Button color="error" variant="contained" onClick={onConfirm}>
          Да, удалить
        </Button>
      </DialogActions>
    </Dialog>
  );
};
